var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgKuCoin = function SvgKuCoin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5313_179352)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0028 26.7602L5.24537 16.0028L16.0028 5.24537L26.7602 16.0028L16.0028 26.7602ZM16.0028 13.0046C14.3521 13.0046 13.0046 14.3465 13.0046 16.0028C13.0046 17.6591 14.3465 19.001 16.0028 19.001C17.6591 19.001 19.001 17.6591 19.001 16.0028C19.001 14.3465 17.6591 13.0046 16.0028 13.0046ZM0.635845 14.4644C-0.211948 15.3122 -0.211948 16.6934 0.635845 17.5356L14.4644 31.3642C15.3122 32.2119 16.6934 32.2119 17.5356 31.3642L31.3642 17.5356C32.2119 16.6878 32.2119 15.3066 31.3642 14.4644L17.5356 0.635845C16.6878 -0.211948 15.3066 -0.211948 14.4644 0.635845L0.635845 14.4644Z",
    fill: "#28CD96"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5313_179352"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
};

export { SvgKuCoin as ReactComponent };
export default __webpack_public_path__ + "aee3b0e66e0729155866e7db6b7bb2a4.svg";